import * as React from 'react';
import './CurrentStatementUsa.scss';
import { IStatementData } from 'src/model/monthlyStatement.model';
import env from 'src/shared/env';

export interface ICurrentStatementUSAProps {
  data: IStatementData[];
  addressLineOne: string;
  addressLineTwo: string;
  addressLineThree: string;
  addressLineFour: string;
  statementDate: string;
  customerNumber: string;
  t?: any;
}

const CurrentStatementUsa: React.SFC<any> = props => {
  const {
    addressLineOne,
    addressLineTwo,
    addressLineThree,
    addressLineFour,
    statementDate,
    customerNumber,
    t
  } = props;
  return (
    <div className="rp-account-statement--current-statement-usa-container">
      <span className="rp-current-statement-title">
        {t('accountMonthlyStatements.currentStatement')}
      </span>
      <div className="rp-current-statement-info-container">
        <div className="rp-current-statement-info">
          <p className="rp-current-statement-info-title">
            {t('accountMonthlyStatements.remitTo')}
          </p>
          <p className="rp-current-statement-info-data">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? 'P.O. Box 673341'
              : '85 North Bend Street'}
          </p>
          <p className="rp-current-statement-info-data">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? 'Dallas, TX 75267-3341'
              : 'Coquitlam, BC'}
          </p>
          {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
            ''
          ) : (
            <p className="rp-current-statement-info-data">'V3K 6N1'</p>
          )}
          <p className="rp-current-statement-info-data">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? '1-800-841-4060' : ''}
          </p>
        </div>
        <div className="rp-current-statement-info">
          <p className="rp-current-statement-info-title">{t('common.phone')}</p>
          <p className="rp-current-statement-info-data">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? '1-800-666-0313'
              : '1-866-985-5301'}
          </p>
        </div>
        <div className="rp-current-statement-info">
          <p className="rp-current-statement-info-title">
            {t('accountMonthlyStatements.fax')}
          </p>
          <p className="rp-current-statement-info-data">
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? '206-575-0910'
              : '1-877-941-7044'}
          </p>
        </div>
        <div className="rp-current-statement-info">
          <p className="rp-current-statement-info-title">
            {t('accountMonthlyStatements.to')}
          </p>
          {addressLineOne && (
            <p className="rp-current-statement-info-data">{addressLineOne}</p>
          )}
          {addressLineTwo && (
            <p className="rp-current-statement-info-data">{addressLineTwo}</p>
          )}
          {addressLineThree && (
            <p className="rp-current-statement-info-data">{addressLineThree}</p>
          )}
          {addressLineFour && (
            <p className="rp-current-statement-info-data">{addressLineFour}</p>
          )}
        </div>
        <div className="rp-current-statement-info">
          <p className="rp-current-statement-info-title">
            {t('accountMonthlyStatements.statementDate')}
          </p>
          <p className="rp-current-statement-info-data">{statementDate}</p>
        </div>
        <div className="rp-current-statement-info">
          <p className="rp-current-statement-info-title">
            {t('accountMonthlyStatements.account')}
          </p>
          <p className="rp-current-statement-info-data">{customerNumber}</p>
        </div>
      </div>
    </div>
  );
};

export default CurrentStatementUsa;
